import * as React from "react";

import { Button } from "src/components/buttons";
import { DataTable } from "src/components/common";

import DatasetAPI from "./DatasetAPI";
import DatasetContext from "src/context/DatasetContext";
import {
	ActionIcon,
	ClearFilterButton,
} from "src/components/forms/ActionColumnIconsAndButton";
import AuthorizationWrapper from "src/common/AuthorizationWrapper";
import { AdminPermissions } from "src/common/Permissions";
import { Tooltip } from "antd";
import {
	setStatusCellValue,
	filterByStatus,
	StatusFilterMethod,
} from "src/components/forms/StatusFilter";

interface IProps {
	match?: any;
	history?: any;
}
interface IOrganizationDatasetsState {
	datasetList: DatasetDTO[];
	filtered: any[];
	loading: boolean;
}

class OrganizationDatasets extends React.Component<
	IProps,
	IOrganizationDatasetsState
> {
	public static contextType = DatasetContext;
	public organizationId = this.props.match.params.organizationId;
	public columns = [
		{
			Header: <Tooltip title="Dataset">Dataset</Tooltip>,
			accessor: "name",
			filterable: true,
		},
		{
			Header: <Tooltip title="Active">Active</Tooltip>,
			accessor: "isActive",
			Cell: setStatusCellValue,
			filterMethod: filterByStatus("isActive"),
			Filter: StatusFilterMethod,
		},
		{
			Header: <Tooltip title="Actions">Actions</Tooltip>,
			accessor: "Actions",
			id: "Actions",
			Cell: (rowInfo: any) => {
				return (
					<span data-id={rowInfo.original.id}>
						<ActionIcon title="Details" type="open" />
					</span>
				);
			},
			Filter: (
				<ClearFilterButton
					onClick={() =>
						this.setState({ filtered: [{ id: "isActive", value: "Active" }] })
					}
				/>
			),
		},
	];

	public constructor(props: any) {
		super(props);
		this.state = {
			datasetList: [],
			filtered: [],
			loading: true,
		};
	}

	public componentDidMount() {
		const { organizationId } = this.props.match.params;

		const p_organizationDatasets = DatasetAPI.getOrganizationDatasets(
			organizationId,
			true,
			true
		);

		Promise.all([p_organizationDatasets]).then((values) => {
			const [datasets] = values;

			this.setState({
				datasetList: datasets,
				loading: false,
			});
		});

		this.setState({ filtered: [{ id: "isActive", value: "Active" }] });
	}

	public render() {
		const columns = this.columns;
		return (
			<div className="container-fluid">
				<AuthorizationWrapper
					type="hide"
					permissions={[AdminPermissions.EditDataset]}
				>
					<div className="d-flex mb-4">
						<div className="ml-3">
							<p className="text-danger font-weight-bold">
								IMPORTANT: If this is part of a multi-org configuration, please
								update the other organization(s) accordingly!
							</p>
						</div>
						<div className="ml-auto">
							<Button
								className="btn btn-primary"
								to={{
									pathname: this.getActionLink(this.organizationId, -1),
								}}
							>
								New Dataset
							</Button>
						</div>
					</div>
				</AuthorizationWrapper>
				<DataTable
					data={this.state.datasetList}
					columns={columns}
					filtered={this.state.filtered}
					onFilteredChange={(filtered: any) => this.setState({ filtered })}
					filterable={true}
					onRowClick={this.onRowClick}
					loading={this.state.loading}
				/>
			</div>
		);
	}

	private getActionLink(orgId: any, rowId: any): string {
		return `/admin/organizations/${orgId}/datasets/${rowId}/details`;
	}

	private onRowClick = ({ original }: { original?: any }) => {
		const currentList = this.state.datasetList.filter(
			(dataset) => dataset.name === original.name
		);
		this.context.updateCurrentDataset(currentList[0]);

		this.props.history.push(
			this.getActionLink(this.organizationId, original.id)
		);
	};
}
export default OrganizationDatasets;
